import React from 'react';

function DirectorEntryCard({
  children,
  statusLabel = '',
  title = ''
}) {
  return (
    <section className="director-card">
      <div className="role-section-header">
        <h2>{title}</h2>
        <span>{statusLabel}</span>
      </div>
      {children}
    </section>
  );
}

export default DirectorEntryCard;
